module.exports = __webpack_public_path__ + "img/manager-ba.f7c1d570.png";